import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Masks, Icons } from '@lsq-frontend/common-ui';
import { formatHbpsInput, handleBpsInput } from './buyer-configuration-helpers';

@Component({
    selector: 'admin-buyer-configuration-past-due',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Past Due Fee"
            sectionFormControlName="pastDueFeeEnabled"
            [sectionFormGroup]="pastDueFeeFormGroup"
        >
            <form [formGroup]="pastDueFeeFormGroup" [style.padding]="'2rem 3rem'">
                <div class="row">
                    <div class="col-12" [style.marginBottom]="'1rem'">
                        <lsq-label
                            label="Past Due Fee Rate*"
                            subLabel="The monthly rate a buyer pays in late fees. Set to whole percentage up to four decimal places. (Setting this enables the Late Payment Feature for this buyer)"
                        ></lsq-label>
                        <lsq-input
                            [basicLabel]="true"
                            name="pastDueFeeRate"
                            formControlName="pastDueFeeRate"
                            [group]="pastDueFeeFormGroup"
                            [textFormatter]="formatHbpsInput"
                            [handleKeypress]="handleBpsInput"
                            [mask]="hbpsAsPercentMask"
                            [appendIcon]="[icons.FaPercent, color.GraphicGray]"
                        >
                        </lsq-input>
                    </div>
                </div>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationPastDueComponent {
    @Input() public pastDueFeeFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;

    public readonly icons = Icons;
    public readonly color = Color;
    public readonly hbpsAsPercentMask = Masks.HbpsAsPercentMask;
    public readonly formatHbpsInput = formatHbpsInput;
    public handleBpsInput = handleBpsInput;
}
